import React from 'react';
import PropTypes from 'prop-types';
import { Text, Flex, Container } from '@chakra-ui/react';
import { generateSectionId } from '../../../utils/generateSectionId';
import SanityBackgroundImage from '../../../atoms/SanityBackgroundImage';

export default function FeaturedStatement({ block }) {
  if (!Object.keys(block).length) return null;

  const { headline, copy, alignment, featuredStatementImage, media } = block;

  const handleAlignment = (leftValue, centerValue, rightValue) => {
    const values = {
      left: leftValue,
      center: centerValue,
      right: rightValue,
    };

    return values[alignment];
  };

  const blockImage = featuredStatementImage || media;

  return (
    <Container {...generateSectionId(block)}>
      <Flex pos="relative" my={[5, null, 10]}>
        <SanityBackgroundImage
          aspectRatio={[1, null, 16 / 9]}
          image={blockImage?.image}
          borderRadius="16px"
          gradientGenerator={url =>
            `linear-gradient(1deg, rgb(0 0 0 / 70%) 14.58%, rgba(0, 0, 0, 0.00) 100%), url(${url}) #d3d3d324 50% / cover no-repeat`
          }
          width="100%"
          height="100%"
          p={[6, null, 16]}
          flexDirection="column"
          justifyContent="flex-end"
          alignItems={handleAlignment('flex-start', 'center', 'flex-end')}
          textAlign={handleAlignment('left', 'center', 'right')}
          as={Flex}
        >
          <Text
            color="typography.lighter"
            as="h2"
            textStyle="h2"
            pb={4}
            fontWeight="black"
          >
            {headline}
          </Text>
          <Text
            color="typography.lighter"
            as="h4"
            textStyle="h4_5_6"
            fontWeight="semibold"
          >
            {copy}
          </Text>
        </SanityBackgroundImage>
      </Flex>
    </Container>
  );
}

FeaturedStatement.propTypes = {
  block: PropTypes.shape({
    featuredStatementImage: PropTypes.shape({
      image: PropTypes.shape({
        asset: PropTypes.shape({
          url: PropTypes.string.isRequired,
        }).isRequired,
        alt: PropTypes.string,
      }).isRequired,
    }),
    media: PropTypes.shape({
      image: PropTypes.shape({
        asset: PropTypes.shape({
          url: PropTypes.string.isRequired,
        }).isRequired,
        alt: PropTypes.string,
      }).isRequired,
    }),
    alignment: PropTypes.oneOf(['left', 'center', 'right']),
    headline: PropTypes.string.isRequired,
    copy: PropTypes.string.isRequired,
  }).isRequired,
};
